<template>
  <div name="reports">

    <div v-if="errored" class="ml-10 mt-4 font-bold text-red-400">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" class="mx-4" v-else>
      <div id="printable">

<section class="bg-white rounded w-full mx-auto px-6 pb-6 pt-4 mt-4 mb-8" v-if="hasAccess" >

 <div class="flex justify-between mb-2">
   <div>
    <h2 class="text-xl font-semibold w-64 inline-block">
       Breakdown
      </h2>
      <div class="text-gray-500 pb-4">
        A breakdown of current totals.
      </div>
   </div>
   <div>
     <ul class="inline-block text-right">
   <li class="inline-block" v-for="item in gradesList" :key="item.key">
      <button  type="button" @click="filterGradeValue(item)"
      class="filter-bar-button hover:opacity-75 focus:outline-none"
                    :style="setGradeBackColor(item)"
                    :class="setGradeTextColor(item)"> 
                       <i class="far" v-bind:class="inGradeFilter(item) ? 'fa-check-square': 'fa-square'" ></i> {{ item.value }}
                     </button>
   </li>
  </ul>
   </div>

  </div>
              <table v-if="componentLoaded" class="table-wrapper w-full">
                         <thead class="bg-gray-100 h-12 rounded">
                           <tr>
                            <th
            v-for="(col, index) in columns"
            :key="index"
            class="pl-2"
            style="min-width: 10em;"
            v-bind:class="col.css"
            @click="sort(col.shortcode)"
          >
            {{ col.label }}
            <i
              v-if="col.shortcode.length > 0"
              class="fas fa-sort tbh-sort"
              v-bind:class="
                col.shortcode === sortBy ? 'text-blue-500' : 'text-gray-400'
              "
            ></i>
          </th>
          <th  style="min-width: 9em;" class="w-1/12 ">
            <div>Attendance</div>
            <div class="text-xs opacity-50 grid grid-cols-3 mx-2">
              <div>K</div>
              <div>A</div>
              <div>I</div>
            </div>
          </th>
                           </tr>
                         </thead>

                         <tbody>
                           <tr class="course" v-for="(item, index) in filteredBreakdowns" :key="index"> 
                              <td > 
                               <div class="pl-2">
                                  {{ item.name }}
                               </div>
                             </td>

                           <td class="text-center opacity-75 bg-opacity-25 "  :style="setGradeColor(item.breakdown.final_grade, 0.25)"> {{ parseToDecimal(item.breakdown.final_grade) }}</td>
                           <td class="text-center opacity-75 bg-opacity-25 ">{{ item.breakdown.outcomegrade_count }}</td>
                           <td class="text-center opacity-75 bg-opacity-25 ">{{ item.breakdown.ec_count }}</td>
                           <td class="text-center opacity-75  bg-opacity-25 ">{{ item.breakdown.event_count }}</td>
                           <td class="text-center opacity-75 bg-opacity-25 ">
                            
                            <div class="text-xs opacity-75 grid grid-cols-3 mx-2">
              <div>{{ parseAttendance('no-kit', item.breakdown.attendance) }}</div>
              <div>{{ parseAttendance('absent', item.breakdown.attendance) }}</div>
              <div>{{ parseAttendance('injured', item.breakdown.attendance) }}</div>
            </div>
                           </td>
                           </tr>
                             
                          
                         </tbody>
                         <tfoot>

                         </tfoot>
                       </table>
                       
                        <p v-else>We could not find any data for your given selection.</p>

   </section>
    <div v-else>
        <UpgradeContent :area="'Reporting'"></UpgradeContent>
      </div>

   </div>

    </div>

    <transition name="fade" v-if="!finishedLoading">
      <div class="loading">
        <span class="fa fa-spinner fa-spin"></span> Loading Reports
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ReportingService } from "@/services/reporting.service"

import { assessmentMixin } from "@/mixins/assessmentMixin.js";

const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");

export default {
  name: "reports",
  props: ["filterValues", "hasAccess"],
  mixins: [assessmentMixin],

  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings"
    }),
    componentLoaded() {
      return this.pupilBreakdowns.length > 0;
    },
    filteredBreakdowns() {
      let vm = this
      const results = vm.pupilBreakdowns.map((a) => a.pupil) 

      if (vm.filteredGrades.length == 0 ) {
        return _.orderBy(results, [vm.sortBy, "name"], [vm.sortDirection]);
      } else {
        let scores = vm.filteredGrades.map(s => s.score)

         var filtered = results.filter(function(aa) {
         
          let value = vm.gradeFromScore(aa.breakdown.final_grade)
          if (value.length > 0) {
            return scores.includes(value[0].score)
          }
          
         });

         return _.orderBy(filtered, [vm.sortBy, "name"], [vm.sortDirection]);
    }
  }
  },
  data() {
    return {
      loading: true,
      finishedLoading: false,
      errored: false,
      pupilBreakdowns: [],
      filteredGrades: [],
      page: 1,
      pageSize: 999,
      currentPage: 1,
      pagination: {},

      sortBy: "name",
      sortDirection: "asc",

      columns: [
        { label: "Name", shortcode: "name", css: "w-5/12 text-left" },
        { label: "Assessment", shortcode: "breakdown.final_grade", css: "w-1/12" },
        { label: "Outcomes", shortcode: "breakdown.outcomegrade_count", css: "w-1/12 text-center" },
        { label: "Extra Curricular", shortcode: "breakdown.ec_count", css: "w-1/12 text-center"},
        { label: "Events", shortcode: "breakdown.event_count", css: "w-1/12" },
      ], // columns
    };
  },
  created() {

  },
  mounted() {
    this.refresh()
  },
  watch: {
    loading(newValue) {
      setTimeout(() => {
        this.finishedLoading = !newValue;
      }, 2000);
    },
    '$props':{
      handler: function (val, oldVal) { 
        this.refresh()
      },
      deep: true
    }
  },

  methods: {
    refresh() {
      this.fetchAssessmentWithFilter()
    },
    async fetchAssessmentWithFilter() {

ReportingService.getBreakdownWithFilter(this.filterValues, this.page, this.pageSize)
  .then((response) => this.pupilBreakdowns = response.data.data)
  .catch((err) => {
    console.log("Activities " + err);
    this.errored = true;
  })
  .finally(() => (this.loading = false));
},
parseToDecimal(value) {
      if (value != undefined) {
        return value.toFixed(2)
      }
      
    },
    parseAttendance(type, attendance) {
      let value = attendance.find((a) => a.attendance_type === type )
      return value ? value.total_count : 0
    },
    setGradeBackColor(grade) {
      return this.inGradeFilter(grade) 
      ? 'background-color:#' + grade.color + ';'
      : 'background-color:#fff'
    },
    setGradeTextColor(grade) {
      return this.inGradeFilter(grade) 
      ? 'text-white'
      : 'text-gray-500 hover:text-white hover:bg-' + grade.color
    },
    filterGradeValue(grade) {
      if (this.containsGrade(grade)) {
        this.filteredGrades.splice(this.filteredGrades.findIndex(item => item.key === grade.key), 1)
      } else {
        this.filteredGrades.push(grade);
      }
    },
    containsGrade(grade) {
      return this.filteredGrades.some(p => p.key === grade.key)
    },
    inGradeFilter(grade) {
      return this.containsGrade(grade)
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
  },
  components: {
UpgradeContent
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
